import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/category-locations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::index
* @see app/Http/Controllers/CategoryLocationController.php:21
* @route '/admin/catalog/category-locations'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/category-locations/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::create
* @see app/Http/Controllers/CategoryLocationController.php:149
* @route '/admin/catalog/category-locations/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\CategoryLocationController::store
* @see app/Http/Controllers/CategoryLocationController.php:172
* @route '/admin/catalog/category-locations'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/catalog/category-locations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::store
* @see app/Http/Controllers/CategoryLocationController.php:172
* @route '/admin/catalog/category-locations'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::store
* @see app/Http/Controllers/CategoryLocationController.php:172
* @route '/admin/catalog/category-locations'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::store
* @see app/Http/Controllers/CategoryLocationController.php:172
* @route '/admin/catalog/category-locations'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::store
* @see app/Http/Controllers/CategoryLocationController.php:172
* @route '/admin/catalog/category-locations'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
export const edit = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/catalog/category-locations/{categoryLocation}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
edit.url = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { categoryLocation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { categoryLocation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            categoryLocation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        categoryLocation: typeof args.categoryLocation === 'object'
        ? args.categoryLocation.id
        : args.categoryLocation,
    }

    return edit.definition.url
            .replace('{categoryLocation}', parsedArgs.categoryLocation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
edit.get = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
edit.head = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
const editForm = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
editForm.get = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::edit
* @see app/Http/Controllers/CategoryLocationController.php:236
* @route '/admin/catalog/category-locations/{categoryLocation}/edit'
*/
editForm.head = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\CategoryLocationController::update
* @see app/Http/Controllers/CategoryLocationController.php:262
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
export const update = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/catalog/category-locations/{categoryLocation}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::update
* @see app/Http/Controllers/CategoryLocationController.php:262
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
update.url = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { categoryLocation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { categoryLocation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            categoryLocation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        categoryLocation: typeof args.categoryLocation === 'object'
        ? args.categoryLocation.id
        : args.categoryLocation,
    }

    return update.definition.url
            .replace('{categoryLocation}', parsedArgs.categoryLocation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::update
* @see app/Http/Controllers/CategoryLocationController.php:262
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
update.put = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::update
* @see app/Http/Controllers/CategoryLocationController.php:262
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
const updateForm = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::update
* @see app/Http/Controllers/CategoryLocationController.php:262
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
updateForm.put = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\CategoryLocationController::destroy
* @see app/Http/Controllers/CategoryLocationController.php:328
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
export const destroy = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/catalog/category-locations/{categoryLocation}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CategoryLocationController::destroy
* @see app/Http/Controllers/CategoryLocationController.php:328
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
destroy.url = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { categoryLocation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { categoryLocation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            categoryLocation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        categoryLocation: typeof args.categoryLocation === 'object'
        ? args.categoryLocation.id
        : args.categoryLocation,
    }

    return destroy.definition.url
            .replace('{categoryLocation}', parsedArgs.categoryLocation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryLocationController::destroy
* @see app/Http/Controllers/CategoryLocationController.php:328
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
destroy.delete = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::destroy
* @see app/Http/Controllers/CategoryLocationController.php:328
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
const destroyForm = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryLocationController::destroy
* @see app/Http/Controllers/CategoryLocationController.php:328
* @route '/admin/catalog/category-locations/{categoryLocation}'
*/
destroyForm.delete = (args: { categoryLocation: string | number | { id: string | number } } | [categoryLocation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const categoryLocations = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default categoryLocations